import styled from '@emotion/styled'

import SignupForm from '@src/components/signup/SignupForm'

const SignupPage = () => {
	return (
		<Block>
			<SignupForm />
		</Block>
	)
}

const Block = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	background: #f1f2f8;
`

export default SignupPage
